import { Route } from 'react-router-dom';
export default Route;
